export default __webpack_public_path__ + "static/media/mixamato-all-day-breakfast.90fad365.jpg";